import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Row, Col, Spinner } from 'reactstrap';
import Translate, { t } from '../common/Translate';
import { getQuotationbyVersionId } from '../../services/SearchVehicle/getVehicleData';
import { currencySign } from '../../Utils/currencySign';

const ValuationVersions = ({ versions, mileage, dateOfRelease }) => {
  const [data, setData] = useState(null);
  let year = null;
  try {
    year = _.parseInt(dateOfRelease.substring(0, 4), 10);
  } catch (e) {
    console.log('parse year failed');
  }

  const collectData = async () => {
    setData('loading');
    try {
      let res = versions.map((version) => getQuotationbyVersionId(version.id, mileage, year));
      res = await Promise.all(res);
      _.remove(res, (o) => o._quotation.tradeIn < 100 || o.standardMileage < 100);
      const dataQuotation = {};
      dataQuotation.min = _.minBy(res, (o) => o._quotation.tradeIn)._quotation.tradeIn;
      dataQuotation.max = _.maxBy(res, (o) => o._quotation.tradeIn)._quotation.tradeIn;
      dataQuotation.standardMileage = _.round(
        _.meanBy(res, (o) => o.standardMileage),
        -2,
      );
      dataQuotation.refurbishmentCost = _.round(
        _.meanBy(res, (o) => o.refurbishmentCost),
        -2,
      );
      dataQuotation.length = versions.length;
      // const data = await getVersions(registration, mileage);
      // data.versions = _.orderBy(data, ["corrected"], ["asc"]);
      setData(dataQuotation);
    } catch (e) {
      setData(null);
    }
  };

  useEffect(() => {
    if (versions && versions.length > 0 && mileage && year) {
      collectData();
    }
  }, [versions, mileage, year]);

  if (versions !== null && versions.length > 20) return null; // in case we have too many versions, we don't call the api to avoid too many requests
  if (!data) return null;
  if (data === 'loading')
    return (
      <Row>
        <Col xs={12} md={6} lg={4} className="text-secondary">
          <Translate code="loading_market_values" />
          <Spinner type="grow" color="primary" size="sm" />
        </Col>
      </Row>
    );

  return (
    <Col xs={12} md={6} lg={4}>
      <Table
        array={[
          {
            label: t('possible_versions'),
            value: data.length,
          },
          {
            label: t('standardMileage'),
            value: `${data.standardMileage} ${t('km')}`,
          },
          {
            label: t('trade_in_values'),
            value:
              data.min !== data.max
                ? `${currencySign(data.min)} ${t('to')} ${currencySign(data.max)}`
                : `${currencySign(data.min)}`,
          },
          {
            label: t('standardRefurbCost'),
            value: currencySign(data.refurbishmentCost),
          },
        ]}
      />
    </Col>
  );
};

export default ValuationVersions;

ValuationVersions.propTypes = {
  versions: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  mileage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dateOfRelease: PropTypes.string,
};

ValuationVersions.defaultProps = {
  versions: null,
  mileage: null,
  dateOfRelease: undefined,
};
const Table = ({ array }) => (
  <table className="table table-sm">
    <tbody>
      {array.map((row, key) => (
        <tr key={row.label} className={key === 0 ? 'no-border' : ''}>
          <td className="text-secondary">{row.label}</td>
          <td className="text-right">{row.value}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

Table.propTypes = {
  array: PropTypes.shape().isRequired,
};
